// extracted by mini-css-extract-plugin
export default {"overlay":"OverlayContainer_overlay__Ham3x","overlayNoBackground":"OverlayContainer_overlayNoBackground__onbvd","container":"OverlayContainer_container__TUzfd"};